<template>
  <tp-table
      :height="500"
      :showPagination="true"
      :tableData="list"
      :columns="columns"
      :totalNum="total"
      :current-page.sync="currentPage"
      :pageSize.sync="pageSize"
  />
</template>

<script>
import { getMemberProductApplyListAPI } from './api.js';

const columns = [
  {
    label: '申请时间',
    prop: 'createTime',
    minWidth: '180',
    customRender(h, row) {
      return <p>{row['createTime']}</p>
    }
  },
  {
    label: '产品名称',
    prop: 'productName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['productName']}</p>
    }
  },
  {
    label: '登录类型',
    prop: 'clientTypeName',
    minWidth: '120',
    customRender(h, row) {
      return <p>{row['clientTypeName']}</p>
    }
  },
  {
    label: '登录渠道',
    prop: 'channelName',
    minWidth: '150',
    customRender(h, row) {
      return <p>{row['channelName']}</p>
    }
  },
];

export default {
  name: 'MemberApplyList',

  props: {
    memberId: {
      type: [Number, String],
      default: ''
    }
  },

  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize:10,
      columns,
    }
  },

  created() {
    this.getList()
  },

  watch: {
    currentPage() {
      this.getList();
    },
    pageSize() {
      this.getList();
    }
  },

  methods: {
    async getList() {
      let params = {
        page: 1,
        pageSize: 20,
        memberId: this.memberId,
      };
      let res = await getMemberProductApplyListAPI(params);
      this.list = res.list || [];
      this.total = res.total || 0;
    }
  }
}
</script>

<style></style>
